module.exports = "/_next/static/images/be-37fc0c68d05a8be91c43d4e9c41569df.svg";